import { useTheme } from '@automata/mui-theme';
import { Box, Stack, Typography } from '@mui/material';
import { FC } from 'react';

import { FieldType } from '../../utils';
import { DynamicFormField } from '../DynamicFormField';

interface SimulateFieldProps {
  instrumentName: string;
  value: boolean;
  isInvalid: boolean;
  isSimulateFieldChanged: (instrument: string) => boolean;
  updateSimulateField: (instrument: string, value: boolean) => void;
}

export const SimulateField: FC<SimulateFieldProps> = ({
  instrumentName,
  value,
  isInvalid,
  isSimulateFieldChanged,
  updateSimulateField,
}) => {
  const theme = useTheme();

  return (
    <Box mb={1}>
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="space-between"
        spacing={1}
      >
        <Box sx={{ flexGrow: 1, maxWidth: '236px' }}>
          <DynamicFormField
            invalid={isInvalid}
            label={'Simulate'}
            required={false}
            type={FieldType.Checkbox}
            value={value}
            onChange={(val) => updateSimulateField(instrumentName, val)}
          />
        </Box>
        {isSimulateFieldChanged(instrumentName) && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: '3px',
              height: '40px',
              width: '81px',
            }}
          >
            <Typography
              color="error"
              fontSize={14}
              sx={theme.typography.overline}
            >
              ●
            </Typography>
          </Box>
        )}
      </Stack>
    </Box>
  );
};
